module.exports = __webpack_public_path__ + "img/green-search-svg.597b5572.svg";